(function () {
  'use strict';
  var KEY = 'yuimart_wishlist_v1';

  function read() {
    try {
      var value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (e) { return []; }
  }

  function write(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    sync(items);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char];
    });
  }

  function plainPrice(value) {
    var holder = document.createElement('div');
    holder.innerHTML = String(value || '');
    return (holder.textContent || holder.innerText || '').trim();
  }

  function sync(items) {
    items = items || read();
    document.querySelectorAll('[data-wishlist-count]').forEach(function (node) {
      node.textContent = items.length;
      node.classList.toggle('is-visible', items.length > 0);
    });

    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var saved = items.some(function (item) { return item.id === button.dataset.productId; });
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var label = button.querySelector('[data-wishlist-button-label]');
      if (label) label.textContent = saved ? 'Saved to Wishlist' : 'Add to Wishlist';
    });
    render(items);
  }

  function render(items) {
    var container = document.querySelector('[data-wishlist-items]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!container || !empty) return;
    empty.hidden = items.length > 0;
    container.innerHTML = items.map(function (item) {
      return '<article class="yuimart-wishlist-item">' +
        '<a class="yuimart-wishlist-item__image" href="' + escapeHtml(item.url) + '">' +
          '<img src="' + escapeHtml(item.image) + '" alt="" loading="lazy">' +
        '</a>' +
        '<div><a class="yuimart-wishlist-item__title" href="' + escapeHtml(item.url) + '">' +
          escapeHtml(item.title) + '</a><div class="yuimart-wishlist-item__price">' +
          escapeHtml(plainPrice(item.price)) + '</div></div>' +
        '<button class="yuimart-wishlist-item__remove" type="button" data-wishlist-remove="' +
          escapeHtml(item.id) + '" aria-label="Remove ' + escapeHtml(item.title) + '">&times;</button>' +
      '</article>';
    }).join('');
  }

  function openDrawer() {
    var drawer = document.querySelector('[data-wishlist-drawer]');
    var overlay = document.querySelector('[data-wishlist-overlay]');
    if (!drawer || !overlay) return;
    render(read());
    overlay.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
    });
    document.body.classList.add('yuimart-wishlist-lock');
  }

  function closeDrawer() {
    var drawer = document.querySelector('[data-wishlist-drawer]');
    var overlay = document.querySelector('[data-wishlist-overlay]');
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('yuimart-wishlist-lock');
    window.setTimeout(function () { if (!overlay.classList.contains('is-open')) overlay.hidden = true; }, 260);
  }

  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-wishlist-open]');
    if (open) { event.preventDefault(); openDrawer(); return; }

    if (event.target.closest('[data-wishlist-close]') || event.target.closest('[data-wishlist-overlay]')) {
      closeDrawer(); return;
    }

    var toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      var items = read();
      var id = toggle.dataset.productId;
      var index = items.findIndex(function (item) { return item.id === id; });
      if (index >= 0) {
        items.splice(index, 1);
      } else {
        items.unshift({
          id: id,
          title: toggle.dataset.productTitle,
          url: toggle.dataset.productUrl,
          image: toggle.dataset.productImage,
          price: toggle.dataset.productPrice
        });
      }
      write(items);
      return;
    }

    var remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      var kept = read().filter(function (item) { return item.id !== remove.dataset.wishlistRemove; });
      write(kept);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('DOMContentLoaded', function () { sync(read()); });
  document.addEventListener('shopify:section:load', function () { sync(read()); });
})();
